// @flow
import { getFiscalYearEndDate } from 'date-functions';
import { addYears, isBefore, parse } from 'date-fns';
import type { DateRange } from './types';

const defaultFiscalYearEnd = '12-31';

const getFiscalYearsForDateRange = (
  dateRange: DateRange,
  clientFiscalYearEnd: ?string,
): Array<number> => {
  const fiscalYearEnd = clientFiscalYearEnd || defaultFiscalYearEnd;
  const startDate = parse(dateRange.startDate);
  const endDate = parse(dateRange.endDate);

  const fiscalYears = [];
  const startDateYear = startDate.getUTCFullYear();
  const startDateFiscalYearEndDate = getFiscalYearEndDate(fiscalYearEnd, startDateYear);
  const fiscalYear = isBefore(startDateFiscalYearEndDate, startDate)
    ? startDateYear + 1
    : startDateYear;
  let fiscalYearEndDate = getFiscalYearEndDate(fiscalYearEnd, fiscalYear);

  fiscalYears.push(fiscalYear);

  while (isBefore(fiscalYearEndDate, endDate)) {
    fiscalYearEndDate = addYears(fiscalYearEndDate, 1);
    fiscalYears.push(fiscalYearEndDate.getUTCFullYear());
  }

  return fiscalYears;
};

export default getFiscalYearsForDateRange;
